import React, {useState, Fragment, useEffect} from 'react'
import {
  Button,
  Row,
  Col,
  Input,
  Select,
  DatePicker,
  Form,
  Space,
  Table, Alert, Spin,
  Divider, Drawer, Descriptions
} from 'antd'
import styles from './index.module.less'
import {
  exportPaymentProgress,
  fetchEnums,
  fetchPaymentDetail,
  fetchPaymentProgress,
  fetchSettlementList,
  fetchSigoCompany
} from './request'
import {expendColumn, getColumns, paymentDetailColumn, payStatusOptions, purchaseAdvanceColumns} from './config'
import moment from 'moment'
import {objToArr, outputMoney} from '@/public/utils'
import DateChoose from '@/compenents/dateChoose'

const FormItem = Form.Item

const layout = {
  // labelCol: {span: 0},
}
const initialPagination = {
  page_size: 10,
  page_no: 1
}
// 对账单付款进度查询
const StatementPaymentProgress = (props) => {
  const [form] = Form.useForm()
  const [searchParams, setSearchParams] = useState(initialPagination)
  const [data, setData] = useState({})
  const [exportLoading, setExportLoading] = useState(false)
  const [company, setCompany] = useState([]) // 结算主体
  const [enums, setEnums] = useState([]) // 支付状态枚举值
  const [loading, setLoading] = useState(false)
  const [settlmentList, setSettlmentList] = useState({}) // 没项结算单数据
  const [settlementLoading, setSettlementLoading] = useState({})
  const [billingDetails, setBillingDetails] = useState({}) // 付款详情
  const [billingDetailsVisible, setBillingDetailsVisible] = useState(false)
  const [drawerLoading, setDrawerLoading] = useState(false)
  const [expendList, setExpendList] = useState([])

  useEffect(() => {
    fetchEnums().then(data => {
      setEnums(data)
    })
    fetchSigoCompany().then(data => {
      const _data = objToArr(data).map(el => ({...el, search: el.label + el.value}))
      setCompany(_data)
      form.setFieldsValue({
        po_subject_code: (_data[0] || {}).value
      })
      searchFun()
    })
  }, [])
  // 查询
  const searchFun = (page = searchParams.page_no, pageSize = searchParams.page_size) => {
    const values = form.getFieldsValue()
    const params = {
      ...searchParams,
      ...values,
      supplier_account_month_str: values.supplier_account_month_str ? moment(values.supplier_account_month_str).format('YYYY-MM') : void 0,
      page_no: page,
      page_size: pageSize
    }
    delete params.supplier_account_date
    setSearchParams(params)
    fetchData(params)
  }

  function fetchData (params) {
    setLoading(true)
    console.log('params', params)
    fetchPaymentProgress(params).then(data => {
      setData(data || {})
      setLoading(false)
      setExpendList([])
    })
  }

  const reloadFun = () => {
    const code = form.getFieldValue('po_subject_code')
    form.resetFields()
    form.setFieldValue('po_subject_code', code)
    setSearchParams(initialPagination)
    searchFun(1, 10)
  }

  // 时间选择器变化时间
  const changeTime = async (time = [], filed) => {
    setSearchParams((prevState) => {
      let query = {...prevState}
      if (time.length > 1) {
        query[`${filed}_begin`] = moment(time[0]).startOf('day')
        query[`${filed}_end`] = moment(time[1]).endOf('day')
      }
      return query
    })
  }
  const exportList = () => {
    setExportLoading(true)
    exportPaymentProgress(searchParams).finally(res => {
      setExportLoading(false)
    })
  }

  // 查询结算单列表
  function getSettlementList (record) {
    setSettlementLoading({...settlementLoading, [record.supplier_account_code]: true})
    fetchSettlementList(record.supplier_account_code).then(data => {
      setSettlmentList({...settlmentList, [record.supplier_account_code]: data})
      setSettlementLoading({...settlementLoading, [record.supplier_account_code]: false})
    })
  }

  const onExpand = (expanded, record) => {
    if (expanded && !settlmentList[record.supplier_account_code]) {
      getSettlementList(record)
    }
  }

  const expandedRowRender = (record, index, indent, expanded) => {
    return (
      <Spin spinning={settlementLoading[record.supplier_account_code]}>
        <Table
          rowKey={'settlement_code'}
          columns={expendColumn({showDetail})}
          dataSource={settlmentList[record.supplier_account_code] || []}
          pagination={false}
          size={'small'}
        />
      </Spin>
    )
  }

  function showDetail (record = {}) {
    const code = record.settlement_code || (record.settlement_code_list || [])[0]
    if (!code) return
    setBillingDetailsVisible(true)
    setDrawerLoading(true)
    fetchPaymentDetail(code).then(data => {
      setBillingDetails(data || {})
    }).finally(() => setDrawerLoading(false))
  }

  return (
    <div>
      <Form form={form} {...layout}>
        <div className={styles.search}>
          <span className={styles.title}>对账单付款进度查询</span>
          <span style={{float: 'right'}}>
            <div hidden={company.length === 1}>
              <FormItem name="po_subject_code" label={'结算主体'} style={{marginLeft: 28}}>
                <Select
                  showSearch
                  optionFilterProp={'search'}
                  placeholder="请选择结算主体"
                  style={{width: 240}}
                  options={company}
                />
              </FormItem>
            </div>
          </span>
          <Divider/>
          <Row>
            <FormItem name="supplier_account_month_str" label={'账单所在月份'}>
              <DatePicker placeholder="请选择账单所在月份" picker="month" allowClear
                style={{width: 240, marginRight: 16}}/>
            </FormItem>
            <FormItem name="supplier_account_code" label={'视客账单号'}>
              <Input placeholder="请输入视客账单号" allowClear style={{width: 240, marginRight: 16}}/>
            </FormItem>
            <FormItem name="supplier_account_date" label={'出账时间'}>
              <DateChoose isStatus time timerChange={(time) => changeTime(time, 'supplier_account_date')}
                style={{marginRight: 16}}/>
            </FormItem>
            <Col style={{textAlign: 'right', flex: 1}}>
              <Space style={{textAlign: 'right'}}>
                <Button type="primary" onClick={() => searchFun(1)}>
                  查询
                </Button>
                <Button onClick={reloadFun}>
                  重置
                </Button>
                <Button type="primary" onClick={exportList} loading={exportLoading}>
                  导出
                </Button>
              </Space>
            </Col>
          </Row>
          <Row>
            <FormItem name="payment_status_str_list" label={'支付状态'} style={{marginLeft: 28}}>
              <Select
                placeholder="支付状态"
                allowClear
                style={{width: 240}}
                options={payStatusOptions}
                mode={'multiple'}
              />
            </FormItem>
            <FormItem name="match_status" label={'匹配状态'} style={{marginLeft: 30}}>
              <Select
                placeholder="匹配状态"
                allowClear
                options={objToArr(enums['发票匹配状态枚举值']).filter(el => el.value !== '03')}
                style={{width: 240}}
                mode={'multiple'}
              />
            </FormItem>
          </Row>
        </div>
      </Form>
      <Alert
        className={styles.alert}
        description={
          <Fragment>
            <span className={styles.fs_14}>
              <span>汇总：</span>
              <span className={styles.ft_bold}>账单金额：</span>
              <span className={styles.color_red}>
                {outputMoney(data.total_statement_amount)}
              </span>
              元
              <span className={styles.ft_bold}>已支付金额：</span>
              <span className={styles.color_red}>
                {outputMoney(data.total_paid_amount)}
              </span>
              元
              <span className={styles.ft_bold}>未支付金额：</span>
              <span className={styles.color_red}>
                {outputMoney(data.total_residue_amount)}
              </span>
              元
              <span className={styles.ft_bold}>已匹配发票金额：</span>
              <span className={styles.color_red}>
                {outputMoney(data.total_invoice_amount)}
              </span>
              元
              <span className={styles.ft_bold}>未匹配发票金额：</span>
              <span className={styles.color_red}>
                {outputMoney(data.total_invoice_remain_amount)}
              </span>
              元
            </span>
          </Fragment>
        }>
      </Alert>
      <Spin spinning={loading}>
        <Table
          rowKey={'supplier_account_code'}
          sticky={true}
          className={styles.table}
          pagination={{
            current: searchParams.page_no,
            showQuickJumper: true,
            total: data.total_size,
            pageSize: searchParams.page_size,
            showSizeChanger: true,
            showTotal: () => {
              return <span
                style={{
                  left: '16px',
                  position: 'absolute'
                }}>共{data.total_size}条，每页{searchParams.page_size}条</span>
            },
            onChange: (current, size) => {
              const _pagination = {
                page_no: size === searchParams.page_size ? current : 1,
                page_size: size
              }
              setSearchParams(prevState => ({...prevState, ..._pagination}))
              searchFun(_pagination.page_no, _pagination.page_size)
            },
            pageSizeOptions: [10, 20, 50, 80]
          }}
          expandable={{
            expandedRowKeys: expendList,
            onExpandedRowsChange: (expandedRows) => {
              setExpendList(expandedRows)
            },
            rowExpandable: record => (record.settlement_code_list || []).length > 1,
            expandedRowRender,
            onExpand
          }}
          // settlement_code_list
          scroll={{x: 1600}}
          dataSource={data.list || []}
          size={'middle'}
          columns={getColumns({showDetail})}
        />
      </Spin>
      <Drawer
        title={'查询付款详情'}
        visible={billingDetailsVisible}
        maskClosable
        onClose={() => {
          setBillingDetailsVisible(false)
        }}
        width={1000}
      >
        <Spin spinning={drawerLoading}>
          <Fragment>
            <Descriptions title="收款信息" column={2} bordered size={'middle'}>
              <Descriptions.Item label="收款账户名">{billingDetails.collection_account_name || '--'}</Descriptions.Item>
              <Descriptions.Item label="收款账户">{billingDetails.collection_account_number || '--'}</Descriptions.Item>
              {billingDetails.abroad_flag
                ? <Fragment>
                  <Descriptions.Item label="收款银行">{billingDetails.opening_bank_name || '--'}</Descriptions.Item>
                  <Descriptions.Item label="银行地址">{billingDetails.full_opening_bank || '--'}</Descriptions.Item>
                  <Descriptions.Item label="swift号">{billingDetails.bank_number || '--'}</Descriptions.Item>
                </Fragment>
                : <Fragment>
                  <Descriptions.Item label="开户行">{billingDetails.opening_bank_name || '--'}</Descriptions.Item>
                  <Descriptions.Item
                    label="开户省市">{billingDetails.province_name + billingDetails.city_name || '--'}</Descriptions.Item>
                  <Descriptions.Item label="开户行全称">{billingDetails.full_opening_bank || '--'}</Descriptions.Item>
                  <Descriptions.Item label="联行号">{billingDetails.bank_number || '--'}</Descriptions.Item>
                </Fragment>
              }
            </Descriptions>
            <Descriptions title="银行付款信息" column={1} style={{marginTop: 16}}>
              <Descriptions.Item>
                <Table
                  style={{width: '100%'}}
                  columns={paymentDetailColumn}
                  pagination={false}
                  size={'middle'}
                  dataSource={billingDetails.payment_list || []}
                  className={styles.table}
                />
              </Descriptions.Item>
              <Descriptions.Item label={'合计'}>
                {outputMoney((billingDetails.payment_list || []).reduce((pre, item) => pre + (item.real_pay_amount || 0), 0))}
              </Descriptions.Item>
            </Descriptions>
            <Descriptions title="预付款信息" column={1}>
              <Descriptions.Item>
                <Table
                  style={{width: '100%'}}
                  columns={purchaseAdvanceColumns}
                  pagination={false}
                  size={'middle'}
                  dataSource={billingDetails.purchase_advance_list}
                />
              </Descriptions.Item>
              <Descriptions.Item label={'合计'}>
                {outputMoney((billingDetails.purchase_advance_list || []).reduce((pre, item) => pre + (item.real_pay_amount || 0), 0))}
              </Descriptions.Item>
            </Descriptions>
          </Fragment>
        </Spin>
      </Drawer>
    </div>
  )
}

export default StatementPaymentProgress



// WEBPACK FOOTER //
// ./src/pages/statementPaymentProgress/index.jsx